import React, { useState, useCallback, useContext } from 'react';
import CloseIcon from '../../Icons/CloseIcon';
import LedgerIcon from '../../Icons/ProviderIcons/LedgerIcon';
import Warning from './Warning';
import DerivationPath from './DerivationPath';
import Accounts from '../Common/Accounts';
import { getLedgerAccounts } from '../../../services/ldgerService';
import { Context } from '../../../stateManagement/store';
import useActionsHook from '../../../stateManagement/actions';
import { WALLET_TYPES, HD_DERIVATION_PATHS } from '../../../constants/wallet';
import '../Common/styles.scss';
import '../Common/Warning.scss';
import {IHDWalletProps} from "../../../interfaces";

const STEPS = {
  WARNING: 0,
  DERIVATION_PATH: 1,
  ACCOUNTS: 2,
};

const Ledger: React.FC<IHDWalletProps> = ({ afterConnect }) => {
  const { dispatch, state } = useContext(Context);

  const actions = useActionsHook(dispatch);

  const [step, setStep] = useState(STEPS.WARNING);
  const [derivationPath, setDerivationPath] = useState(HD_DERIVATION_PATHS.LIVE.value);
  const [offset, setOffset] = useState(0);
  const [accounts, setAccounts] = useState([]);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const onWarningConfirm = useCallback(() => setStep(STEPS.ACCOUNTS), []);
  const onAdvancedClick = useCallback(() => setStep(STEPS.DERIVATION_PATH), []);
  const onModeSelect = useCallback((path) => {
    setDerivationPath(path);
    setStep(STEPS.ACCOUNTS);
  }, []);
  const loadMoreAccounts = useCallback(async () => {
    if (!loading) {
      setLoading(true);
      setError(undefined);
      try {
        const nextAccounts = await getLedgerAccounts({ ledgerPath: derivationPath, accountsOffset: offset });
        setAccounts([...accounts, ...nextAccounts]);
        setOffset(offset + 5);
      } catch (err) {
        setError(err.message);
      }
      setLoading(false);
    }
  }, [offset, accounts, derivationPath, loading]);
  const onClose = useCallback(() => {
    actions.closeLedgerFunnel();
  }, [actions]);

  const onConfirmAddress = useCallback(async (index, savePath) => {
    if (!accounts.length) {
      onClose();
    }
    await actions.connectWallet({
      connectionType: WALLET_TYPES.ledger, ...(state.network || {}), ledgerPath: derivationPath.replace('x', index), savePath,
    });
    afterConnect();
  }, [onClose, actions, state.network, derivationPath, accounts, afterConnect]);

  const { connectingWallet, connectionError } = state;

  return (
    <div className="web3-wc_hd-wallet ledger">
      <CloseIcon className="web3-wc_close-modal-btn ledger web3-wc_modal-icon-btn" onClick={onClose}>X</CloseIcon>
      <div className="web3-wc_hd-wallet-icon">
        <LedgerIcon />
      </div>
      {step === STEPS.WARNING && <Warning onClick={onWarningConfirm} onAdvancedClick={onAdvancedClick} />}
      {step === STEPS.DERIVATION_PATH && <DerivationPath onConfirm={onModeSelect} />}
      {step === STEPS.ACCOUNTS && (
        <Accounts
          walletName="Ledger"
          onConfirm={onConfirmAddress}
          accounts={accounts}
          loading={loading}
          loadMoreAccounts={loadMoreAccounts}
          connecting={connectingWallet}
          connectionError={connectionError}
          error={error}
        />
      )}
    </div>
  );
};

export default Ledger;
